import { getArchive, getGlobals } from "storyblok/api"
import { getCategoryArchiveWinsAndReviews, getWinAndReviewsCategories } from "storyblok/winsAndReviews"
import Meta from "components/Meta"
import CategoryArchiveSection from "components/Archive/CategoryArchiveSection"
import WinsAndReviewCard from "components/WinsAndReviewCard"
import ArchiveHeader from "components/Archive/ArchiveHeader"
import { getCategoryArchiveWinsAndReviewsApi } from "storyblok/winsAndReviewsApi"
import { CardListSection } from "components/Archive/CardListSection"

export default function WinsAndReviewArchive({ items, categories, total, perPage, currentPage, meta, story }) {
  return (
    <>
      <Meta info={meta} />
      <main data-pagefind-ignore="all">
        <ArchiveHeader story={story?.content} breadcrumbs={[{ text: "Wins & Reviews", href: "/wins-and-reviews" }]} />
        <CategoryArchiveSection
          categories={categories}
          archiveLink="/wins-and-reviews"
          categoryLinkPrefix="/wins-and-reviews/category/"
          currentTab={{ name: "All", value: "all" }}
          list={<CardListSection
            key="all"
            items={items}
            total={total}
            perPage={perPage}
            currentPage={currentPage}
            columns={3}
            backgroundColor="highlight-tint"
            handler={(params) => getCategoryArchiveWinsAndReviewsApi(params)}
            Card={WinsAndReviewCard} />}
        />
      </main>
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals("exclude-global-sections")

  const { items, total, currentPage, perPage } = await getCategoryArchiveWinsAndReviews()
  const categories = await getWinAndReviewsCategories()
  const story = await getArchive("wins-and-reviews", preview)

  return {
    props: {
      meta: story?.content?.twentysixty_seo ?? null,
      story: story ?? null,
      items: items ?? null,
      total, 
      currentPage, 
      perPage,
      categories: categories ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}
